/**
 * hellopanda-sticky
 */
import Sticky from './sticky';
const HELLOPANDA_STICKY = {
  resizeSet: new Set(),
  resizeWidth: window.innerWidth,
  resizeHeight: window.innerHeight,
  resizeHeightAllow: 120,
  debounce: function(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  },
  // setMinHeight: function(stickyBlocks) {
  //   stickyBlocks.forEach(stickyBlock => {
  //     let beforeHeight = 0;
  //     const innerDom = stickyBlock.querySelector(' & > .wp-block-template-part');
  //     const targetDom = innerDom ? innerDom : stickyBlock ;
  //     const resizeObserver = new ResizeObserver(entries => {
  //       entries.forEach(entry => {
  //         if (beforeHeight != entry.contentRect.height) {
  //           beforeHeight = entry.contentRect.height;
  //           const cover = stickyBlock.closest('.wp-block-hellopanda-sticky-block');
  //           if (cover) {
  //             cover.style.minHeight = innerDom ? innerDom.offsetHeight + 'px' : stickyBlock.offsetHeight + 'px' ;
  //             // console.log(cover, cover.style.minHeight);
  //           }
  //         }
  //       });
  //     });
  //     resizeObserver.observe(targetDom);
  //   });
  // },
  setMinHeight: function(stickyBlocks, element) {
    stickyBlocks.forEach(stickyBlock => {
      const container = stickyBlock.closest('.wp-block-hellopanda-sticky-block');
      const firstChild = stickyBlock.querySelector(':scope > :first-child');
      if (container && firstChild) {
        container.style.minHeight = firstChild.offsetHeight + 'px';
      }
    });
  },
  init: function() {

    // let Sticky;
    // try {
    //   Sticky = require('sticky-js');
    // } catch (error) {
    //   console.warn("Sticky-js module not found, the Sticky-js effect is disabled.");
    // }

    const _ = this;
    
    if (typeof Sticky === 'function') {

      // 제어할 객체가 있을때만 실행
      const stickyBlocks = document.querySelectorAll('.wp-block-hellopanda-sticky-item-block');
      if (!stickyBlocks.length) {
        return;
      }

      window.hellopanda = window.hellopanda || {} ;
      window.hellopanda.library = window.hellopanda.library || {} ;
      window.hellopanda.library.sticky = new Sticky('.wp-block-hellopanda-sticky-item-block');

      // 현재 브레이크포인트 결정
      let lastBreakPoint = null; // 바깥에 저장 (캐시 역할)

      // 윈도우 리사이즈 시 스티키 업데이트, debounce로 콜을 지연시킴
      const debouncedUpdate = () => {

        const currentWidth = window.innerWidth;
        let currentBreakPoint = '';

        if (currentWidth < 780) {
          currentBreakPoint = 'mobile';
        } else if (currentWidth < 1024) {
          currentBreakPoint = 'tablet';
        } else {
          currentBreakPoint = 'desktop';
        }

        // 이전에 계산된 값과 비교하여, 현재 브레이크포인트가 바뀌었을 때만 계산
        if (currentBreakPoint != lastBreakPoint) {
          window.hellopanda.library.sticky?.elements?.forEach(element => {
            const top = element.dataset.marginTop;
            const tabletTop = element.dataset.marginTabletTop;
            const mobileTop = element.dataset.marginMobileTop;

            if (element.sticky && (tabletTop || mobileTop)) {
              let newMarginTop = parseInt(top, 10); // 기본은 desktop
        
              if (currentBreakPoint === 'mobile' && mobileTop) {
                newMarginTop = parseInt(mobileTop, 10) || 0;
              } else if (currentBreakPoint === 'tablet' && tabletTop) {
                newMarginTop = parseInt(tabletTop, 10) || 0;
              }
        
              if (element.sticky.marginTop !== newMarginTop) {
                element.sticky.marginTop = newMarginTop;
              }
            }
            lastBreakPoint = currentBreakPoint;
          });
        }

        // 높이 다시 체크
        _.setMinHeight(stickyBlocks);

        // 스티키 블록 업데이트
        window.hellopanda.library.sticky.update();

      };

      // window.addEventListener('resize', debouncedUpdate);

      // 구독형 리사이즈 ( IOS 개선 )
      const handleResize = _.debounce(() => {
        if (_.checkResize()) {
          _.resizeNotify();
        }
      }, 30);
      window.addEventListener('resize', handleResize.bind(this));

      // 구독으로 리사이즈 실행
      _.resizeSubscribe(() => {
        debouncedUpdate();
      });

      window.addEventListener("scroll", (event) => {
        debouncedUpdate();
      });
      window.addEventListener("load", (event) => {
        debouncedUpdate();
      });

      // 스티키 적용 체크
      if (stickyBlocks.length) {
        document.addEventListener('readystatechange', () => {
          if (document.readyState === 'complete') {
            stickyBlocks.forEach(stickyBlock => {
              stickyBlock.classList.add('wp-block-hellopanda-sticky-executed');

              // 스티키 블록을 클릭했을 때 높이를 업데이트
              // 탭 등 예외 높이 현상에 대한 대처 2025.05.10
              stickyBlock.addEventListener('click', () => {
                debouncedUpdate();
              });

            });
          }
        });
      }

      // 높이 미리 체크
      document.addEventListener("DOMContentLoaded", function () {
        _.setMinHeight(stickyBlocks);
      });
    }

  },

  // 진짜 resize 발생 여부 확인
  checkResize() {
    const _ = this;
    const w = window.innerWidth;
    const h = window.innerHeight;
    let changed = false;

    if (w !== _.resizeWidth) {
      _.resizeWidth = w;
      changed = true;
    } else if (Math.abs(h - _.resizeHeight) >= _.resizeHeightAllow) {
      _.resizeHeight = h;
      changed = true;
    }

    return changed;
  },

  // 모든 구독자에게 알림
  resizeNotify: function() {
    const _ = this;
    _.resizeSet.forEach(fn => fn(_.resizeWidth, _.resizeHeight));
  },

  // 모듈이 리사이즈 감지에 참여할 때
  resizeSubscribe: function(fn) {
    const _ = this;
    _.resizeSet.add(fn);
    return () => _.resizeSet.delete(fn);
  },

};
HELLOPANDA_STICKY.init();